import path from 'path';

export class ListController {
  constructor (apicontroller, listconfig) {
    this.apicontroller = apicontroller;
    this.listconfig = listconfig;
  }

  getUri (relativeuri) {
    return path.join(this.listconfig.controller, relativeuri);
  }

  async Get (relativeuri, obj) {
    return this.apicontroller.Get(this.getUri(relativeuri), obj);
  }
  /**
   * @param  {String} searchkey
   */
  async GetList (searchkey, page, pageSize, internalSettings) {
    let obj = {
      searchKey: searchkey,
      page: page,
      pageSize: pageSize
    };
    if (this.listconfig.params) {
      let addParameters = this.listconfig.params;
      if (this.listconfig.params instanceof Function) {
        addParameters = this.listconfig.params();
      }
      obj = { ...obj, ...addParameters };
    }
    obj = { ...obj, ...internalSettings };
    return this.Post(this.listconfig.listMethod, obj);
  }
  /**
   * @param  {Number} autoid
   */
  async GetItem (autoid) {
    let obj = {
      AutoID: autoid
    };
    return this.Post(this.listconfig.singleMethod, obj);
  }

  async Post (relativeuri, obj) {
    return this.apicontroller.Post(this.getUri(relativeuri), obj);
  }
}
